import { ReactNode } from "react";

import Badge from "@mui/material/Badge";
import ListItemIcon from "@mui/material/ListItemIcon";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import BottomRightDotBadge from "components/bottom-right-dot-badge/bottom-right-dot-badge.component";

type SideMenuItemContentProps = {
  isActive: boolean;
  primary: string;
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
  badgeContent?: ReactNode;
  isDotWarning?: boolean;
};

export default function SideMenuItemContent({
  isActive,
  primary,
  Icon,
  badgeContent,
  isDotWarning
}: SideMenuItemContentProps) {
  const theme = useTheme();

  return (
    <>
      <ListItemIcon
        sx={{
          minWidth: 0,
          justifyContent: "center"
        }}
      >
        <Badge badgeContent={badgeContent} color="primary" sx={{ zIndex: 0 }}>
          {isDotWarning ? (
            <BottomRightDotBadge
              badgeContent={isDotWarning ? "1" : undefined}
              variant="dot"
            >
              <Icon
                sx={{
                  color: isActive
                    ? theme.palette.common.white
                    : theme.palette.neutral[500]
                }}
              />
            </BottomRightDotBadge>
          ) : (
            <Icon
              sx={{
                color: isActive
                  ? theme.palette.common.white
                  : theme.palette.neutral[500]
              }}
            />
          )}
        </Badge>
      </ListItemIcon>

      <Typography
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "16px",
          lineHeight: 1,
          fontWeight: isActive ? "fontWeightBold" : "fontWeightRegular",
          textDecoration: "none",
          whiteSpace: "nowrap",
          height: "22px",
          color: isActive
            ? theme.palette.common.white
            : theme.palette.neutral[500]
        }}
      >
        {primary}
      </Typography>
    </>
  );
}
